// Status vocabulary, mirroring awards-service's
// internal/services/membership/transitions.go. Reconcile by hand: the upstream
// @tempmee/awards package is ESM-only with a hard zod@^4 peer dep, so taking it
// as a dependency would drag zod into this repo for a labels map.

export const CYCLE_STATUSES = ['pending', 'active', 'complete'];

export const CYCLE_STATUS_LABELS = {
  pending: 'Pending',
  active: 'Active',
  complete: 'Complete',
};

export const MEMBERSHIP_STATUSES = [
  'nominee',
  'applicant',
  'winner',
  'not-selected',
];

/**
 * Not a stored status — it is the absence of a membership row. The single-target
 * PUT does accept it (nominee -> not-entered returns 200 and removes the row),
 * but removal is deliberately kept to the CSV workflow so it stays auditable:
 * direct removal drops the member's edit_history (see GOTU-5627). The select
 * therefore offers it only as a permanently disabled, explained option.
 */
export const NOT_ENTERED = 'not-entered';

export const MEMBERSHIP_STATUS_LABELS = {
  nominee: 'Nominee',
  applicant: 'Applicant',
  winner: 'Winner',
  'not-selected': 'Not Selected',
  'not-entered': 'Not Entered',
};

/** DNT and HYG map to admin profile routes; ADM has no profile page. */
export const USER_TYPE_TO_PROFILE = {
  DNT: 'office',
  HYG: 'professional',
};

const CSV_ONLY_REMOVAL =
  'Removal is done through CSV upload to keep an audit trail.';
const WINNER_IS_TERMINAL = 'Winner is final. Use CSV upload to correct.';

// Mirrors legalTransitions in awards-service
// internal/services/membership/transitions.go.
export const LEGAL_TRANSITIONS = {
  [NOT_ENTERED]: ['nominee'],
  nominee: ['applicant', 'not-selected'],
  applicant: ['winner', 'not-selected'],
  'not-selected': ['nominee'],
  winner: [],
};

const OPTION_ORDER = [...MEMBERSHIP_STATUSES, NOT_ENTERED];

/**
 * Every status the select should render, in a fixed order, each carrying
 * whether it is selectable and why not. Returning the full set (rather than
 * filtering) lets the UI grey illegal targets with an explanation instead of
 * silently hiding them.
 */
export const getStatusOptions = (currentStatus) => {
  const legal = LEGAL_TRANSITIONS[currentStatus] ?? [];
  const currentLabel = MEMBERSHIP_STATUS_LABELS[currentStatus] ?? currentStatus;

  return OPTION_ORDER.map((value) => {
    const label = MEMBERSHIP_STATUS_LABELS[value];

    if (value === NOT_ENTERED) {
      return { value, label, disabled: true, disabledReason: CSV_ONLY_REMOVAL };
    }
    if (value === currentStatus) {
      return { value, label, disabled: true };
    }
    if (legal.includes(value)) {
      return { value, label, disabled: false };
    }

    return {
      value,
      label,
      disabled: true,
      disabledReason:
        currentStatus === 'winner'
          ? WINNER_IS_TERMINAL
          : `Cannot change from ${currentLabel} to ${label}.`,
    };
  });
};
